import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import Personnel from 'src/models/personnel/Personnel';
import useFetch from 'use-http';
import _ from 'lodash';
import 'src/styles/pages/_accountsPayable.scss';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';

interface IChooseVouchersDialogProps {
    dialogName: string;
    handleSelectedVouchers?: (person: Personnel) => void;
    hideDialog: () => void;
}

const ChooseVouchersDialog = (props: IChooseVouchersDialogProps) => {
    const { get, response } = useFetch();
    // const { register, errors, getValues } = useForm();
    const { getValues } = useForm();
    const [selectedPerson, setSelectedPerson] = useState<Personnel>(undefined);
    const [personnelList, setPersonnelList] = useState<Array<Personnel>>(undefined); // The whole personnel list
    const [personnelSearchResults, setPersonnelSearchResults] = useState<Array<Personnel>>(undefined); // The personnel filtered by search (Name)

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (personnelSearchResults) {
            console.log('PersonnelSearchResults Updated', personnelSearchResults);
        }
    }, [personnelSearchResults]);

    const onCreate = () => {
        search();
        getPersonnel();
        console.log('ChooseVouchersDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleSelectedVouchers(selectedPerson);
        props.hideDialog();
    };

    const search = _.debounce(() => {
        let searchName = getValues()?.search;

        let personnelResults = personnelList;
        if (searchName?.length) {
            searchName = searchName?.toLowerCase();

            console.log(searchName);
            personnelResults = personnelResults?.filter(person => person.lastName.toLowerCase().includes(searchName));
        } 
        setPersonnelSearchResults(personnelResults);
    }, 800);

    /**
     * Gets the list of Personnel Users and stores in personnelList
     */
    const getPersonnel = async () => {
        let result = await get(`/v1.0/landmen`);
        if (response.ok && result) {
            setPersonnelList(result.items);
            setPersonnelSearchResults(result.items);
        } else {
            console.log('Unable to get the Personnel Data!!! >:c');
        }
    };

    return (
        <Dialog title="Choose Vouchers to Pay" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '55%' }}>
            <div style={{marginTop: '3rem', overflowY: 'scroll', height: '20rem'}}>
                <form>
                    <table>
                        <thead style={{ textAlign: 'center' }}>
                            <tr>
                                <th style={{ width: '5%' }}/>
                                <th className="find-person-header" style={{ width: '10%' }}>Due Date</th>
                                <th className="find-person-header" style={{ width: '7%' }}>Vndr #</th>
                                <th className="find-person-header" style={{ width: '12%' }}>Vendor</th>
                                <th className="find-person-header" style={{ width: '5%' }}>Voucher</th>
                                <th className="find-person-header" style={{ width: '10%' }}>Inv. Date</th>
                                <th className="find-person-header" style={{ width: '5%' }}>Amount</th>
                                <th className="find-person-header" style={{ width: '11%' }}>Chk #</th>
                                <th className="find-person-header" style={{ width: '11%' }}>Check Date</th>
                                <th className="find-person-header" style={{ width: '20%' }}>Description</th>
                            </tr>
                        </thead>
                        {personnelSearchResults?.map((person: Personnel, index: number) => {
                            return (
                                <tbody key={person.id}>
                                    <tr 
                                        className="table-item-hover" 
                                        style={person?.id === selectedPerson?.id ? { background: 'yellow', textAlign: 'left' } : { textAlign: 'left' }} 
                                        onClick={() => setSelectedPerson(person)}
                                    >
                                        <td style={{ width: '5%' }}>
                                            <RHFCheckbox name={''}/>
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            <label>11/10/2024</label>
                                        </td>
                                        <td style={{ width: '7%' }}>
                                            <label>4775</label>
                                        </td>
                                        <td style={{ width: '12%' }}>
                                            <label>GreatAmerica Financial</label>
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>39354</label>
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            <label>10/16/2024</label>
                                        </td>
                                        <td style={{ width: '5%' }}>
                                            <label>127.15</label>
                                        </td>
                                        <td style={{ width: '11%' }}>
                                            <label>{}</label>
                                        </td>
                                        <td style={{ width: '11%' }}>
                                            <label>{}</label>
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            <label>Inv. 37679666</label>

                                        </td>
                                    </tr>
                                </tbody>
                                );
                            })}
                    </table>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
                {/* <Button
                    className="blue-hover-button"
                    style={{ width: '12%', marginRight: '1rem' }}
                    text={'Add Other'}
                    onClick={() => props.hideDialog()}
                /> */}
            </div>
        </Dialog>
    );
};

export default ChooseVouchersDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/ChooseVouchersDialog.tsx